export default {
  title: null,
  drawer: null,
  color: 'primary',
}
